/**
 * Comprehensive polyfill setup for browser compatibility
 * This module should be imported as early as possible to ensure polyfills
 * are available before any third-party libraries (like Kendo PDF/PDF.js) load
 */
// Core ES2015+ polyfills that are commonly needed
import 'core-js/stable/array/at';
import 'core-js/stable/array/find';
import 'core-js/stable/array/find-index';
import 'core-js/stable/array/flat';
import 'core-js/stable/array/flat-map';
// Additional polyfills that might be needed for PDF.js and other third-party libraries
import 'core-js/stable/array/includes';
import 'core-js/stable/object/assign';
import 'core-js/stable/object/entries';
import 'core-js/stable/object/from-entries';
import 'core-js/stable/object/keys';
import 'core-js/stable/object/values';
import 'core-js/stable/promise/all-settled';
import 'core-js/stable/string/replace-all';

/**
 * Additional polyfill for globalThis which is used by modern web workers
 * This ensures compatibility with PDF.js and other libraries that use globalThis
 */
if (typeof globalThis === 'undefined') {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (global as any).globalThis = global;
}

/**
 * Inject polyfills into the global scope for web workers
 * This is a workaround for third-party web workers that don't include polyfills
 */
export function injectPolyfillsIntoGlobalScope(): void {
  // Make core-js polyfills available globally for web workers
  if (typeof window !== 'undefined') {
    // In main thread, ensure polyfills are on window object
    const win = window as any;

    // Ensure Array.prototype.at is available globally
    if (!win.Array?.prototype?.at) {
      win.Array = Array;
    }
  }

  // For web worker contexts
  if (typeof self !== 'undefined' && typeof window === 'undefined') {
    // We're in a web worker context
    const worker = self as any;

    // Ensure polyfills are available on the global scope
    if (!worker.Array?.prototype?.at) {
      worker.Array = Array;
    }
  }
}

// Auto-initialize polyfills
injectPolyfillsIntoGlobalScope();
